import React, {useState} from "react";
import {DatePicker, Form, Input, Modal, Select} from "antd";
import {useStore} from "hooks/useStore";
import {EXIT_REASONS} from "./courierLifecycleConstants";
import locale from "antd/es/date-picker/locale/tr_TR";
export const TerminateCourierModal = ({visible, onClose, courierId, onSuccess}) => {
    const stores = useStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            const result = await stores.courierStore.terminateCourier(courierId, {
                ...values,
                officialQuitDate: values.officialQuitDate?.format("YYYY-MM-DD"),
                ossEndDate: values.ossEndDate?.format("YYYY-MM-DD")
            });
            if (result.success) {
                form.resetFields();
                onClose();
                onSuccess();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="İşten Çıkar"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="İşten Çıkar"
            cancelText="İptal"
            confirmLoading={loading}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="officialQuitDate"
                    label="Resmi Çıkış Tarihi"
                    rules={[{required: true, message: "Resmi çıkış tarihi zorunludur"}]}
                >
                    <DatePicker style={{width: "100%"}} format="DD.MM.YYYY" locale={locale} />
                </Form.Item>
                <Form.Item
                    name="ossEndDate"
                    label="ÖSS Bitiş Tarihi"
                    rules={[{required: true, message: "ÖSS bitiş tarihi zorunludur"}]}
                >
                    <DatePicker style={{width: "100%"}} format="DD.MM.YYYY" locale={locale} />
                </Form.Item>
                <Form.Item
                    name="reason"
                    label="Çıkış Nedeni"
                    rules={[{required: true, message: "Çıkış nedeni zorunludur"}]}
                >
                    <Select placeholder="Çıkış nedeni seçin" options={EXIT_REASONS} />
                </Form.Item>
                <Form.Item
                    name="pttTerminated"
                    label="PTT Çıkışlı mı?"
                    rules={[{required: true, message: "Bu alan zorunludur"}]}
                >
                    <Select placeholder="Seçin">
                        <Select.Option value={true}>Evet</Select.Option>
                        <Select.Option value={false}>Hayır</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="hrNote"
                    label="Çıkış Açıklaması (İK)"
                    rules={[{required: true, message: "Çıkış açıklaması zorunludur"}]}
                >
                    <Input.TextArea rows={3} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
